export const isLargeText = () => {
    const el = document.createElement('div');
    el.style.width = '1rem'; // use width instead of fontSize to avoid CSS overrides
    document.body.appendChild(el);
    const remSize = parseFloat(getComputedStyle(el).width);
    document.body.removeChild(el);

    const hasLargeText = remSize > 16; // default is 16px
    return hasLargeText;
}
export default isLargeText;